<!-- Start Header for Desktop/Tablet -->
<header class="header-sm" role="banner">
  <div class="container-fluid d-lg-flex justify-container-between">
    <div class="row my-3 navbar-header">

      <div>

        <a class="logo" style="width:100%;">
          <img style="width:110px;height:auto;" class="mr-2" src="assets/images/nsw-logo.svg" alt="NSW Government - Biodiversity Conservation Trust">
          <span class="logo-text mb-1">Biodiversity<br> Conservation <br>Trust</span>
        </a>

      </div>

    </div>

  </div>
</header>
<!-- End Header for Desktop/Tablet -->
